import { post } from '../axios'

// 工作台权限管理-查询所有功能模块
export function v1_portal_module_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/portal/module/list`,
    map,
    option
  ).then(response => response)
}

// 工作台权限管理-添加一条记录
export function v1_portal_module_add_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/portal/module/add`,
    map,
    option
  ).then(response => response)
}

// 工作台权限管理-删除一条记录
export function v1_portal_module_delete_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/portal/module/delete`,
    map,
    option
  ).then(response => response)
}

// 工作台权限管理-更新一条记录
export function v1_portal_module_update_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/portal/module/update`,
    map,
    option
  ).then(response => response)
}

// 工作台权限管理-根据角色ID查询所有的模块
export function v1_portal_module_byRoleId_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/portal/module/byRoleId`,
    map,
    option
  ).then(response => response)
}
